module.exports = __webpack_public_path__ + "static/media/snowflake-logo.b72b4408.svg";